export function loadLineLiffSDK() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.charset = 'utf-8'
    script.src = 'https://static.line-scdn.net/liff/edge/versions/2.26.1/sdk.js'
    document.body.appendChild(script)
    script.onload = resolve
    script.onerror = reject
  })
}
